import React, { useEffect, useState } from 'react';
import { ApiBridgeAlert } from '../../api/models';
import BridgeAlerts from './BridgeAlerts';
import { bridgeAlertApi } from '../../apis';

interface AlertProps {
  personId: string;
}

export const PersonBridgeAlerts = ({ personId }: AlertProps) => {
  const [fetching, setFetching] = useState(false);
  const [alerts, setAlerts] = useState<ApiBridgeAlert[]>([]);
  const [page, setPage] = useState<number>(0);
  const size = 20;
  const [total, setTotal] = useState<number>(0);

  const fetchAlerts = async () => {
    const alertsPage = await bridgeAlertApi.findAllBridgeAlerts({
      personId,
      page,
      size,
    });
    setAlerts(alertsPage.content);
    setTotal(alertsPage.total);
  };

  const updateAlerts = async () => {
    setFetching(true);
    await fetchAlerts();
    setFetching(false);
  };

  useEffect(() => {
    fetchAlerts();
  }, [personId, page]);

  return (
    <BridgeAlerts
      page={page}
      size={size}
      total={total}
      loading={fetching}
      alerts={alerts}
      expandable
      expandedByDefault={false}
      attributes={[
        { key: 'ID', sortable: false },
        { key: 'Date', sortable: false },
        { key: 'Assignee', sortable: false },
        { key: 'Status', sortable: false },
        { key: 'Actions', sortable: false },
      ]}
      onUpdate={updateAlerts}
      onUpdatePage={setPage}
    />
  );
};

export default PersonBridgeAlerts;
